/* global gon */
// @flow
import React from 'react'
import AnalysisStatus from '../../../components/shared/Header/AnalysisStatus'

type Props = {}

export default class AnalysisStatusContainer extends React.Component<Props> {
  render () {
    const analysisFailed = gon.project.failed
    const analysisUpdatedAt = gon.project.last_synchronisation_at
    return <AnalysisStatus
      failed={analysisFailed}
      updatedAt={analysisUpdatedAt}
    />
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/shared/Header/AnalysisStatusContainer.js